const data = {
  data: [
    {
      IdCIFEmpresa: 1,
      Cliente: 'ClientePrueba1',
      IdCliente: 1,
      CIF: 'A12345678',
      RazonSocial: 'empresa1',
      Activo: true,
      certAsociado: 'Cert',
      EnviarAvisos: false,
      FechaAlta: '2021-05-25T15:33:56.000000Z',
      Agrupaciones: [],
      EmailTecnico: 'prueba@zerocoma.com',
      Direccion: 'Calle de prueba Nº',
      CodigoPostal: '27390',
      Poblacion: 'MADRID',
      Provincia: 'MADRID',
      Pais: 'España',
      Telefono: '625384756',
      Grupos: [
        { IdGrupo: 1, Empresa: 'EmpresaPrueba', Nombre: 'GrupoPrueba1', idTipo: 1, Tipo: 'Gestor Facturas', Usuarios: ['carlos.santos'], EnUso: true, VerTodoGrupos: true, VerTodoEstados: true, VerTodoEmpresas: true, idCliente: 1, active: true, },
        { IdGrupo: 2, Empresa: 'EmpresaPrueba', Nombre: 'GrupoPrueba2', idTipo: 2, Tipo: 'Gestión', Usuarios: [], EnUso: true, VerTodoGrupos: true, VerTodoEstados: true, VerTodoEmpresas: true, idCliente: 1, active: true, }
      ]
    },
    {
      IdCIFEmpresa: 2,
      Cliente: 'ClientePrueba1',
      IdCliente: 1,
      CIF: 'A12345678',
      RazonSocial: 'empresa2',
      Activo: true,
      certAsociado: 'Cert',
      EnviarAvisos: false,
      FechaAlta: '2021-05-25T15:33:56.000000Z',
      Agrupaciones: [],
      EmailTecnico: 'prueba@zerocoma.com',
      Direccion: 'Calle de prueba Nº',
      CodigoPostal: '27390',
      Poblacion: 'MADRID',
      Provincia: 'MADRID',
      Pais: 'España',
      Telefono: '625384756',
      Grupos: [
        { IdGrupo: 2, Empresa: 'EmpresaPrueba', Nombre: 'GrupoPrueba2', idTipo: 2, Tipo: 'Gestión', Usuarios: [], EnUso: true, VerTodoGrupos: true, VerTodoEstados: true, VerTodoEmpresas: true, idCliente: 1, active: true, }
      ]
    },
    {
      IdCIFEmpresa: 3,
      Cliente: 'ClientePrueba1',
      IdCliente: 1,
      CIF: 'A12345678',
      RazonSocial: 'empresa3',
      Activo: true,
      certAsociado: 'Cert',
      EnviarAvisos: false,
      FechaAlta: '2021-05-25T15:33:56.000000Z',
      Agrupaciones: [],
      EmailTecnico: 'prueba@zerocoma.com',
      Direccion: 'Calle de prueba Nº',
      CodigoPostal: '27390',
      Poblacion: 'MADRID',
      Provincia: 'MADRID',
      Pais: 'España',
      Telefono: '625384756',
      Grupos: []
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
